import type { PopulatedMenu, ShowcasePopulatedItem } from 'root/apiTypes';
import type { HttpClientFactory } from './utils/types';
import { MenusClient } from './MenusClient';
import { SectionsClient } from './SectionsClient';
import { PopulatedItemsClient } from './ItemsClient';
import { populateMenu } from 'root/api/utils/populateMenu';
import { completeMissingEntities } from 'root/api/utils/completeMissingEntities';

export const PopulatedMenuClient: HttpClientFactory<PopulatedMenu> = (httpClient) => {
  const MenusApi = MenusClient(httpClient);
  const SectionsApi = SectionsClient(httpClient);
  const PopulatedItemsApi = PopulatedItemsClient(httpClient);

  return {
    getAll: async ({ paging }) => {
      const [menus, sections, populatedItems] = await Promise.all([
        MenusApi.getAll({ paging }),
        SectionsApi.getAll({ paging }),
        PopulatedItemsApi.getAll({ paging }),
      ]);

      await completeMissingEntities({
        menus: menus.data,
        sections,
        getSections: SectionsApi.getAll,
        populatedItems,
        getPopulatedItems: PopulatedItemsApi.getAll,
        maxNumberOfEntitiesToLoad: paging?.limit,
      });

      return {
        data: menus.data.map((menu) =>
          populateMenu(menu, sections.data, (populatedItems?.data ?? []) as ShowcasePopulatedItem[])
        ) as PopulatedMenu[],
      };
    },
  };
};
